import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = 'home' as const;

// Responsible Use Link
export const mkResponsibleUseLinkTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__responsible_use_link`, props);

// Logo
export const mkLogoTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__logo`, props);

// Privacy Policy Link
export const mkPrivacyLinkTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__privacy_link`, props);

export const mkContactLinkTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__contact_link`, props);

// Suggestion Button
export const mkSuggestionBtnTrackAttrs = (props: {
  index: number;
  visibleSuggestionCount: number;
  label: string;
  prompt: string;
}) => mkTrackAttrs(`${PREFIX}__suggestion_btn`, props);

// ToS Link
export const mkTosLinkTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__tos_link`, props);
